import map from 'lodash/map';

const migrationEnabledCompanies = [
  {
    id: '56bfef41a17441a959d9c8d5', // sprinklr
    mappingUrl: 'https://lyearn.s3.amazonaws.com/lyearn/sprinklr-redirecturi.json'
  },
  {
    id: '5bc7121480b9690022a28b22', // sprinklr parteners
    mappingUrl: 'https://lyearn.s3.amazonaws.com/lyearn/sprinklrpartners-redirecturi.json'
  },
  {
    id: '5f23bd1a1cc1672bd3c9ec79', // cxmadmin
    mappingUrl: 'https://lyearn.s3.amazonaws.com/lyearn/cxmadmin-redirecturi.json'
  },
  {
    id: '5c9ddb52b6a9db00153c865d', // sprinklru
    mappingUrl: 'https://lyearn.s3.amazonaws.com/lyearn/sprinklru-redirecturi.json'
  }
  /* {
    id: '56bfef41a17441a959d9c8da', // playpower1 (for testing)
    mappingUrl: 'https://lyearn.s3.amazonaws.com/lyearn/sprinklr-redirecturi.json'
  } */
];

export const migrationEnabledCompanyIds = map(migrationEnabledCompanies, 'id');

export default migrationEnabledCompanies;
